import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import {
  repairsData,
  repairsDataPost,
  repairsDataDelete,
  repairsDataID,
  repairsDataPage,
} from "./repairsActions";
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

import {RepairRequest, InsertRepair, RepairRequestLength} from '../../types/request.type';

type RepairsState = {
  dataRepairsPage: {
    payload: RepairRequestLength | null;
    loading: boolean;
    success: boolean;
    error: string | null;
  };
};

const initialState: RepairsState = {
  dataRepairsPage: {
    payload: null,
    loading: false,
    success: false,
    error: "",
  },
};




const repairsSlicePage = createSlice({
  name: "repairsPage",
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры
    setRepairsState(state, action: PayloadAction<RepairRequestLength>) {
      const stateNew = state;
      stateNew.dataRepairsPage.payload =  {} as RepairRequestLength; //[];
      stateNew.dataRepairsPage.payload = action.payload;
      state = stateNew;
    },

    setRepairState(state, action: PayloadAction<RepairRequestLength>) {
      state.dataRepairsPage.payload = {} as RepairRequestLength;
      state.dataRepairsPage.payload = action.payload;
    },


  },

  extraReducers: (builder) => {
    builder
      .addCase(repairsDataPage.pending, (state) => {
        state.dataRepairsPage.loading = true;
        state.dataRepairsPage.error = null;
      })
      .addCase(repairsDataPage.fulfilled, (state, action) => {
        state.dataRepairsPage.loading = false;
        repairsSlicePage.caseReducers.setRepairsState(state, action);
      })
      .addCase(repairsDataPage.rejected, (state, action) => {
        state.dataRepairsPage.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataRepairsPage.error = errorText ? errorText : "";
      })


  },
});


const getErrorText = (error: ErrorResponse) => {
  console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
};

export default repairsSlicePage.reducer;
